export default function getLabelFromIndex(index: number) {
  return String(index + 1);
}
